import { render, staticRenderFns } from "./transfer-credits.vue?vue&type=template&id=2d564afd&scoped=true"
import script from "./transfer-credits.vue?vue&type=script&lang=js"
export * from "./transfer-credits.vue?vue&type=script&lang=js"
import style0 from "./transfer-credits.vue?vue&type=style&index=0&id=2d564afd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d564afd",
  null
  
)

export default component.exports